import { Injectable } from '@angular/core';
import { ScopeRegistryType } from '../types';

@Injectable({ providedIn: 'root' })
export class ScopeRegistry {
  #items: Map<string, string> = new Map<string, string>();

  public register(value: ScopeRegistryType | ScopeRegistryType[]): void {
    if (Array.isArray(value)) {
      value.forEach((item) => this.#items.set(item.scope, item.resolver));
    } else {
      this.#items.set(value.scope, value.resolver);
    }
  }

  public get(scope: string): string | undefined {
    return this.#items.get(scope);
  }
}
